export default {"src":"/_next/static/media/desktop-bg.b1bcf270.svg","height":900,"width":1024,"blurWidth":0,"blurHeight":0};